import {Outlet, Scripts, ScrollRestoration} from "@remix-run/react";
import {GlobalPendingIndicator} from "@/components/global-pending-indicator";
import React from "react";

export default function () {
    return (
            <div className={"flex-grow border-l-2 "}>
                <GlobalPendingIndicator />
                <div className="h-dvh">
                    <Outlet />
                </div>
                <ScrollRestoration />
                <Scripts />
            </div>
    )
}
